import React from 'react';
import { useField } from 'formik';

// PROPS Optional
// secondlabel -> if you want put other label on side the primary label
// icon -> if you want put icon in input
// clickicon -> if you want icon to be able to click

const InputComponent = ({
  label,
  required,
  disabled,
  textColorLabel = 'text-gray-900',
  textColorRequired = 'text-gray-400',
  ...props
}) => {
  const [field, meta] = useField(props);
  const errorClass =
    'block w-full rounded-md border-0 py-1.5 shadow-sm text-red-900 ring-1 ring-inset ring-red-300 placeholder:text-red-300 focus:ring-2 focus:ring-inset focus:ring-red-500 sm:text-sm sm:leading-6';
  const classInput =
    'block w-full rounded-md border-0 py-1.5 shadow-sm text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-main sm:text-sm sm:leading-6 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200';

  if (props.icon) {
    const passInputProps = {
      name: props.name,
      type: props.type,
    };
    return (
      <div className="w-full">
        {label && (
          <div className="flex items-center justify-between">
            <div className="flex items-center justify-between gap-1">
              <label className={`block text-sm font-medium leading-6 ${textColorLabel}`}>{label}</label>
              {required && (
                <label className={`block text-xs font-light leading-6 ${textColorRequired}`}>{`(required)`}</label>
              )}
            </div>
            {props.secondlabel ? <div>{props.secondlabel}</div> : <></>}
          </div>
        )}

        <div className="relative mt-1">
          <input
            className={`${meta.error ? errorClass : classInput} pr-10`}
            {...field}
            {...passInputProps}
            disabled={disabled}
          />
          {props.clickicon ? (
            <div
              onClick={props.clickicon}
              className="pointer-events absolute inset-y-0 right-0 flex items-center pr-3">
              {props.icon}
            </div>
          ) : (
            <div className="pointer-events absolute inset-y-0 right-0 flex items-center pr-3">
              {props.icon}
            </div>
          )}
        </div>
        {meta.touched && meta.error ? (
          <div className="text-red-600 mt-1 text-sm">{meta.error}</div>
        ) : null}
      </div>
    );
  }

  return (
    <div className="w-full">
      {label && (
        <div className="flex items-center justify-between">
          <div className="flex items-center justify-between gap-1">
            <label className={`block text-sm font-medium leading-6 ${textColorLabel}`}>{label}</label>
            {required && (
              <label className={`block text-xs font-light leading-6 ${textColorRequired}`}>{`(required)`}</label>
            )}
          </div>
          {props.secondlabel ? <div>{props.secondlabel}</div> : <></>}
        </div>
      )}
      <div className="mt-1">
        <input
          className={meta.error ? errorClass : classInput}
          {...field}
          {...props}
          disabled={disabled}
        />
      </div>
      {meta.touched && meta.error ? (
        <div className="text-red-600 mt-1 text-sm">{meta.error}</div>
      ) : null}
    </div>
  );
};

export default InputComponent;
